import React from 'react';
import type { AccessState } from '@lingoping/core';
import { trialLineText } from './accessText.js';
import { BRAND } from './brand.js';

/** The top bar's "Trial: 9 days left · Subscribe" (nothing once subscribed). */
export const TrialLine: React.FC<{ access: AccessState; now?: Date }> = ({ access, now }) => {
  const text = trialLineText(access, now);
  if (!text) return null;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '4px 12px',
        borderRadius: 999,
        background: BRAND.tint,
        color: BRAND.deep,
        fontSize: 14,
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}
    >
      {text}
      <span aria-hidden>·</span>
      <a href="#subscribe" style={{ color: BRAND.dark, fontWeight: 700 }}>
        Subscribe
      </a>
    </span>
  );
};
